import React, { Fragment, useContext, useCallback, useMemo } from "react";
import styles from "./ResourceMonitor.module.scss";
import ShiftCard from "./Calandars/ShiftCard";
import {
  AddIconSvgBlack,
  BackIcon,
  NotFoundIcon,
} from "../../../modules/default-svg";
import Button from "../../../components/controls/button";
import { ResourcePlannerContext } from "./ResourcePlannerContext";
import NotFoundLayout from "../../../components/controls/NotFound/NotFound";

const AssignedShiftCard = ({ formBody, userDetails }) => {
  const {
    addShiftView,
    setAddShiftView,
    calendarData,
    detail,
    tabView,
    setAssignedResources,
    setSelectedDays,
    setStartDate,
    setEndDate,
    setSelectedShift,
    editShift,
    setEditShift,
    setSelectedValue,
  } = useContext(ResourcePlannerContext);

  const handleEditShift = useCallback((item) => {
    setAddShiftView(true);
    setAssignedResources([{ id: userDetails.id, fullName: userDetails.name }]);
    setSelectedDays(item.daysOfWeek);
    setStartDate(new Date(item.startDate));
    setEndDate(new Date(item.endDate));
    setSelectedShift(item.id);
    setEditShift(true);
  }, [userDetails, setAddShiftView, setAssignedResources, setSelectedDays, setStartDate, setEndDate, setSelectedShift, setEditShift]);

  const handleCancel = useCallback(() => {
    setSelectedDays([]);
    setAssignedResources([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedValue(null);
    setAddShiftView(false);
  }, [setSelectedDays, setAssignedResources, setStartDate, setEndDate, setSelectedValue, setAddShiftView]);

  const handleAssignClick = useCallback(() => {
    setAssignedResources([{ id: userDetails.id, fullName: userDetails.name }]);
    setAddShiftView(true);
    setEditShift(false);
  }, [userDetails, setAssignedResources, setAddShiftView, setEditShift]);

  // Memoize the shifts data
  const shiftsData = useMemo(() => {
    if (!calendarData || !detail || !calendarData[detail.userIndex]) {
      return [];
    }

    if (tabView !== "hour") {
      return calendarData[detail.userIndex][detail.ind]?.[0]?.data || [];
    }

    // For hourly view, we need the hourly identifier
    // This should be passed from the parent or calculated
    return [];
  }, [calendarData, detail, tabView]);

  return (
    <div className={styles.TaskCardContainer}>
      {!addShiftView ? (
        <Fragment>
          <div className={styles.cardSubHeader}>
            <h5>Assigned Shifts</h5>
            <Button
              btnClass="d_btn d_btn_whiteXsm"
              icon={<AddIconSvgBlack />}
              label={"Assign"}
              clickHandler={handleAssignClick}
            />
          </div>
          <div className={styles.CalendarModalScroll}>
            {shiftsData.length > 0 ? (
              <div
                className={`${styles.cardBody}`}
                style={{
                  maxHeight: "500px",
                }}
              >
                {shiftsData.map((item) => (
                  <ShiftCard 
                    key={item.id} 
                    handleEditShift={handleEditShift} 
                    item={item} 
                  />
                ))}
              </div>
            ) : (
              <NotFoundLayout
                icon={<NotFoundIcon />}
                heading="No data currently available!"
                para=""
              />
            )}
          </div>
        </Fragment>
      ) : (
        <>
          <div
            className="d-flex align-items-center cursor-pointer gap-1 mb-3"
            onClick={handleCancel}
          >
            <BackIcon />
            <span className="text-xsm-400 AvatarColor">
              Back to assigned shifts
            </span>
          </div>
          <div className={styles.CalendarSubModalScroll}>{formBody()}</div>
        </>
      )}
    </div>
  );
};

export default AssignedShiftCard;
